/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarBasicDtoFromJSON, CarBasicDtoToJSON, } from './';
export function ReservationBasicDtoFromJSON(json) {
    return ReservationBasicDtoFromJSONTyped(json, false);
}
export function ReservationBasicDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'reservationId': !exists(json, 'reservationId') ? undefined : json['reservationId'],
        'car': !exists(json, 'car') ? undefined : CarBasicDtoFromJSON(json['car']),
        'hasAgreement': !exists(json, 'hasAgreement') ? undefined : json['hasAgreement'],
        'agreementId': !exists(json, 'agreementId') ? undefined : json['agreementId'],
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'begins': !exists(json, 'begins') ? undefined : (new Date(json['begins'])),
        'ends': !exists(json, 'ends') ? undefined : (new Date(json['ends'])),
    };
}
export function ReservationBasicDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reservationId': value.reservationId,
        'car': CarBasicDtoToJSON(value.car),
        'hasAgreement': value.hasAgreement,
        'agreementId': value.agreementId,
        'createdById': value.createdById,
        'createdBy': value.createdBy,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'description': value.description,
        'begins': value.begins === undefined ? undefined : (value.begins.toISOString()),
        'ends': value.ends === undefined ? undefined : (value.ends.toISOString()),
    };
}
